import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, ToggleControl, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';
import img from '../../public/img/header2-cover-img.jpg'

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcHeaderPadding,
        hfcHeaderInnerWidth,
        hfcHeaderBGcolor,
        hfcHeaderLinksColor,
        hfcHeaderLinksHoverColor,
        hfcHeaderLinkCurrentColor,
        hfcHeaderLabelColor,
        hfcHeaderIconColor,
        hfcHeaderBtncolor,
        hfcHeaderBtnHovercolor,
        hfcHeaderBorderColor,
        hfcSubmenusBgHoverColor,
        hfcHeaderHasBorder,
        hfcHeaderIsTransparent,
        hfcHeaderIconsSize,
        hfcHeaderLabelSize,
        hfcHeaderIsSticky,
        hfcHeaderBoxShadow,
        hfcHeaderTitleBadge,
        hfcHeaderDescBox,
        hfcHasHeaderBGimg,
        hfcImageWidth,
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: ('hfc-header-' + clientIdSliced) });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'core/site-logo',
        'core/navigation',
        'core/navigation-link',
        'core/social-links',
        'core/paragraph',
        'core/buttons',
        'core/button'
    ];
    const TEMPLATE = [
        [
            "core/group",
            { tagName: "header" },
            [
                [
                    "core/group",
                    { className: "hfc-first-container" },
                    [
                        [
                            "core/columns",
                            { verticalAlignment: "center", className: "hfc-col-header-1" },
                            [
                                [
                                    "core/column",
                                    { width: "30%", className: "hfc-col-left" },
                                    [
                                        [
                                            "core/social-links",
                                            { className: "social-link" },
                                            [
                                                ["core/social-link", { service: "x", url: "#" }],
                                                ["core/social-link", { service: "facebook", url: "#" }],
                                                ["core/social-link", { service: "linkedin", url: "#" }],
                                                [
                                                    "core/social-link",
                                                    { service: "pinterest", url: "#" },
                                                ],
                                            ],
                                        ],
                                    ],
                                ],
                                [
                                    "core/column",
                                    {
                                        width: "70%",
                                        className: "hfc-col-right",
                                    },
                                    [
                                      [
                                        "hfc-blocks/icon-list", {}, [
                                          ["hfc-blocks/list-item", {
                                              spanText: "1241 Benedum Drive",
                                              icon: "faLocationDot"
                                          }]
                                        ]
                                    ],
                                    [
                                          "hfc-blocks/icon-list", {}, [
                                            ["hfc-blocks/list-item", {
                                                spanText: "+1-321-752-2004",
                                                icon: "faPhone",
                                                isLinkable: true,
                                                url: 'tel:+1-321-752-2004'
                                            }]
                                          ]
                                    ],
                                        [
                                            "core/buttons",
                                            {},
                                            [
                                                [
                                                    "core/button",
                                                    {
                                                        text: "Get Started!",
                                                        url: "#",
                                                        rel: "nofollow",
                                                        style: {
                                                            typography: { fontSize: "18px" },
                                                        },
                                                    },
                                                ],
                                            ],
                                        ],
                                    ],
                                ],
                            ],
                        ],
                    ],
                ],
                [
                    "core/group",
                    { className: "hfc-second-container" },
                    [
                        [
                            "core/columns",
                            {
                                verticalAlignment: "center",
                                className: "hfc-col-header-2",
                            },
                            [
                                [
                                    "core/column",
                                    { width: "", className: "hfc-col-left" },
                                    [
                                        [
                                            "core/site-logo",
                                            {
                                                className: " ",
                                            },
                                        ],
                                    ],
                                ],
                                [
                                    "core/column",
                                    { width: "", className: "hfc-col-right" },
                                    [
                                        [
                                            "core/navigation",
                                            {
                                                className: "hfc-nav-header-2",
                                                showSubmenuIcon: false,
                                                icon: "menu"
                                            },
                                            [
                                                [
                                                    "core/navigation-link",
                                                    {
                                                        label: "Home",
                                                        url: "#",
                                                    },
                                                ],
                                                [
                                                    "core/navigation-link",
                                                    {
                                                        label: "Services",
                                                        url: "#",
                                                    },
                                                ],
                                                [
                                                    "core/navigation-submenu",
                                                    {
                                                        label: "Portfolio",
                                                        url: "#",
                                                        className: "hfc-submenu-wrapper"
                                                    },
                                                    [
                                                        [
                                                            "core/navigation-link",
                                                            {
                                                                label: "Portfolio 1",
                                                                url: "#",
                                                            },
                                                        ],
                                                        [
                                                            "core/navigation-link",
                                                            {
                                                                label: "Portfolio 2",
                                                                url: "#",
                                                            },
                                                        ],
                                                        [
                                                            "core/navigation-link",
                                                            {
                                                                label: "Portfolio 3",
                                                                url: "#",
                                                                title: "new",
                                                            },
                                                        ],
                                                    ],
                                                ],
                                                [
                                                    "core/navigation-link",
                                                    {
                                                        label: "Blog",
                                                        url: "#",
                                                        description: '',
                                                    },
                                                ],
                                                [
                                                    "core/navigation-link",
                                                    {
                                                        label: "About Us",
                                                        url: "#",
                                                    },
                                                ],
                                            ],
                                        ],
                                    ],
                                ],
                            ],
                        ],
                    ],
                ],
            ],
        ],
    ];

    const hfcDynamicStyles = `/* Theme Compatibility - GeneratePress */
    .editor-styles-wrapper .wp-block-hfc-blocks-header-2 .hfc-main-header-2 .block-editor-block-list__block{
        max-width: 100%!important;
    }
    .editor-styles-wrapper .wp-block-post-content{
      padding: 0;
    }
    .editor-styles-wrapper .wp-block-hfc-blocks-header-2 .wp-block-group__inner-container {
        padding: 0px!important;
        max-width: 100%;
    }
    .editor-styles-wrapper .wp-block-hfc-blocks-header-2 .wp-block {
        margin: 0px;
    }
    .editor-styles-wrapper .hfc-main-header-2 .wp-block-navigation__submenu-container .wp-block-navigation-item__label::after{
       display: none!important;
    }
    .block-editor-block-list__block.wp-block.wp-block-hfc-blocks-header-2 {
      max-width: 100%;
    }
    #${id}.hfc-main-header-2 {
      ${hfcHeaderHasBorder ? `border-bottom: 1px solid ` + hfcHeaderBorderColor : ``};
    }
    #${id}.hfc-main-header-2 .hfc-second-container {
      background-color: ${hfcHeaderBGcolor};
      position: relative;
      z-index: 999;
      padding: 0px 10px;
    }
    #${id}.hfc-main-header-2 .hfc-second-container:before{
      content: '';
      height: 100%;
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 3px;
      left: 0;
      ${hfcHasHeaderBGimg ? `background-image: url(${img});` : ''}
      background-repeat: repeat;
      z-index: -1;
    }
    #${id}.hfc-main-header-2 .wp-block-columns {
      justify-content: space-between;
    }
    #${id}.hfc-main-header-2 .hfc-col-header-1,
    #${id}.hfc-main-header-2 .hfc-col-header-2{
      max-width: ${hfcHeaderInnerWidth}!important;
      margin: 0 auto;
      align-items: center!important;
    }
    #${id}.hfc-main-header-2 .hfc-first-container p,
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons {
      margin: 0;
      display: inline-block;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-social-links .wp-social-link{
      transition: 0.4s;
      transform: scale(1);
      list-style: none;
      line-height: 1;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-social-links .wp-social-link:hover{
      transform: scale(1.1);
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons .wp-block-button__link{
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
      padding: 10px 20px;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons>.wp-block-button .wp-block-button__link {
     background-color: ${hfcHeaderBtncolor};
     border-radius: 0;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons>.wp-block-button .wp-block-button__link:hover {
      background-color: ${hfcHeaderBtnHovercolor};
    }
    #${id}.hfc-main-header-2 .hfc-col-left{
      flex-basis: 30%;
    }
    #${id}.hfc-main-header-2 .hfc-col-right{
      display: flex;
      gap: 15px;
      align-items: center;
      justify-content: flex-end;
      flex-basis: 70%;
    }
    #${id}.hfc-main-header-2 .hfc-first-container {
      background-color: #18202B;
      color: #fff;
    }
  #${id}.hfc-main-header-2 .hfc-first-container ul {
    gap: 0;
    flex-wrap: nowrap;
  }
  #${id}.hfc-main-header-2 .hfc-first-container li {
    background-color: transparent;
    color: #fff;
    border-right: 1px solid rgba(209, 209, 209, 0.24);
    border-radius: 0;
    padding: 0 5px;
  }
  #${id}.hfc-main-header-2 .hfc-first-container li svg{
    width: ${hfcHeaderIconsSize}px;
    height: ${hfcHeaderIconsSize}px;
    fill: #fff;
  }
  #${id} .hfc-nav-header-2 .wp-block-navigation-item.has-mega-menu, 
  #${id} .hfc-nav-header-2 .wp-block-navigation-item.has-child {
    padding-right: 15px;
  }
  #${id}.hfc-main-header-2 .hfc-first-container,
  #${id}.hfc-main-header-2 .hfc-second-container{
    margin: 0;
  }
  #${id} .wp-block-navigation.hfc-nav-header-2 .wp-block-navigation__container > .wp-block-navigation-submenu > a{
      position: relative;
  }
  #${id} .wp-block-navigation.hfc-nav-header-2 .wp-block-navigation__container > .wp-block-navigation-submenu > a::after{
      content: '';
      position: absolute;
      top: 50%;
      margin-top: -4px;
      margin-left: 4px;
      box-sizing: border-box;
      height: 8px;
      width: 8px;
      border-style: solid;
      border-color: ${hfcHeaderLinksColor};
      border-width: 0px 2px 2px 0px;
      transform: rotate(45deg);
  }
  #${id} .wp-block-navigation.hfc-nav-header-2 .wp-block-navigation-submenu > a:hover::after{
      border-color: ${hfcHeaderLinksHoverColor};
  }
  #${id} .wp-block-navigation .wp-block-navigation-link a:focus .wp-block-navigation-item__label, 
  #${id} .wp-block-navigation .wp-block-navigation-link.current-menu-item .wp-block-navigation-item__label{
    border-bottom: none!important;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .hfc-col-left .wp-block-site-logo{
    padding: 5px 0;
    max-width: ${hfcImageWidth}!important;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-item a.wp-block-navigation-item__content {
    color: ${hfcHeaderLinksColor};
    font-weight: bold;
    font-size: 18px;
    text-decoration: none;
    padding: 8px 16px;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-item a.wp-block-navigation-item__content:hover .wp-block-navigation-item__label{
    color: ${hfcHeaderLinksHoverColor};
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-submenu .wp-block-navigation__submenu-icon{
    margin-top: -24px;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-submenu .wp-block-navigation__submenu-icon svg{
    stroke: ${hfcHeaderLinksColor};
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-submenu:hover .wp-block-navigation__submenu-icon svg{
    stroke: ${hfcHeaderLinksHoverColor};
  }
  ${hfcHeaderTitleBadge ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[title]:after {
    content: attr(title);
    position: relative;
    top: -14px;
    font-size: 10px;
    font-weight: bold;
    line-height: 10px;
    text-transform: uppercase;
    display: inline-block;
    padding: 3px 4px;
    background: #F44336;
    color: #fff;
}
#${id} ul.hfc-nav-header-2 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]:after {
  top: 4px;
  left: 10px;
  height: 100%;
}` : ``}
#${id}.hfc-main-header-2 .wp-block-navigation-item:hover .wp-block-navigation-item__description{
  display: block;
  position: absolute;
  right: 50%;
  transform: translate(50%, 50%);
  min-width: 200px;
  max-width: 200px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  padding: 10px;
  border-radius: 5px;
}
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container > .wp-block-navigation-item > a.wp-block-navigation-item__content{
    padding: ${hfcHeaderPadding}px 0px;
    border-bottom: 4px solid transparent;
    line-height: 30px;
    display: inline-block;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container > .wp-block-navigation-item:hover > a.wp-block-navigation-item__content{
    border-bottom-color: ${hfcHeaderLinksHoverColor};
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container{
    display: flex;
    gap: 25px;
  }
  #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[aria-current="page"] {
      color: ${hfcHeaderLinkCurrentColor} !important;
  }
  #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[aria-current="page"]:before {
      width: 100% !important;
      background: ${hfcHeaderLinkCurrentColor} !important;
  }
  ${hfcHeaderIsSticky ? `#${id}.hfc-main-header-2 {
      position: sticky;
      top: 0;
      z-index: 999;
  }` : ``}
  ${hfcHeaderIsTransparent ? `#${id}.hfc-main-header-2 {
      position: absolute;
      top: 0;
  }` : ``}
  ${hfcHeaderBoxShadow ? `#${id}.hfc-main-header-2 {
      box-shadow: 0 4px 7px rgb(199 199 199 / 10%);
  }` : ``}
 #${id} .hfc-icon-list-main{
     margin-top: 0;
  }
 #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
      background-color: transparent!important;
 }
#${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner span,
#${id} .hfc-first-container .hfc-icon-list-main .wp-block-hfc-blocks-list-item a{
     color: ${hfcHeaderLabelColor}!important;
     font-size: ${hfcHeaderLabelSize}px!important;
}
.editor-styles-wrapper #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner svg{
     height: ${hfcHeaderIconsSize}px!important;
     width: ${hfcHeaderIconsSize}px!important;
     color: ${hfcHeaderIconColor}!important;
}
.editor-styles-wrapper #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
     padding: 0px!important;
}
  /* Edit Page Compatibility */
  /* Astra */
  .ast-separate-container .edit-post-visual-editor__content-area, .ast-separate-container .edit-post-visual-editor{
    padding: 0px!important;
  }
  .editor-styles-wrapper .block-editor-block-list__block  a.wp-block-navigation-item__content{
    text-decoration: none;
  }
  .editor-styles-wrapper .block-editor-block-list__block .components-button{
    background-color: transparent;
    border: none;
  }
  .editor-styles-wrapper ul.block-editor-block-list__block,
  .editor-styles-wrapper{
    margin: 0px;
    padding: 0px;
  }
  .editor-styles-wrapper nav.wp-block{
    margin-right: unset!important;
  }
  .editor-styles-wrapper .block-list-appender.wp-block{
    display: none;
  }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Header Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <Heading className={'frhd__pb-heading'}>Header Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ hfcHeaderPadding: newValue })}
                    isDragEnabled
                    value={hfcHeaderPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Header Inner Width :')}
                    onChange={newValue => setAttributes({ hfcHeaderInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcHeaderInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Header Icon Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ hfcHeaderIconsSize: newValue })}
                    isDragEnabled
                    value={hfcHeaderIconsSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Header Label Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({hfcHeaderLabelSize: newValue })}
                    isDragEnabled
                    value={hfcHeaderLabelSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Header Background Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Links Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinksColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Links Hover Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Link Current Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinkCurrentColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinkCurrentColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Icon Color :</Heading>
                <ColorPalette
                    value={hfcHeaderIconColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderIconColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon List Label Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLabelColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLabelColor: colorValue })}
                    clearable={false}
                />  
                <Heading className={'frhd__pb-heading'}>Header Button Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBtncolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBtncolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Button Hover Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBtnHovercolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBtnHovercolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Border Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Background Hover Color :</Heading>
                <ColorPalette
                    value={hfcSubmenusBgHoverColor}
                    onChange={(colorValue) => setAttributes({hfcSubmenusBgHoverColor: colorValue })}
                    clearable={false}
                />
                <ToggleControl
                    label={
                        hfcHeaderHasBorder
                            ? 'Header Border :'
                            : 'Header Border :'
                    }
                    checked={hfcHeaderHasBorder}
                    onChange={newValue => setAttributes({ hfcHeaderHasBorder: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderIsSticky
                            ? 'Header Sticky :'
                            : 'Header Sticky :'
                    }
                    checked={hfcHeaderIsSticky}
                    onChange={newValue => setAttributes({ hfcHeaderIsSticky: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderBoxShadow
                            ? 'Header Box Shadow :'
                            : 'Header Box Shadow :'
                    }
                    checked={hfcHeaderBoxShadow}
                    onChange={newValue => setAttributes({ hfcHeaderBoxShadow: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderTitleBadge
                            ? 'Show Title as Badge :'
                            : 'Show Title as Badge :'
                    }
                    checked={hfcHeaderTitleBadge}
                    onChange={newValue => setAttributes({ hfcHeaderTitleBadge: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderDescBox
                            ? 'Description on Hover :'
                            : 'Description on Hover :'
                    }
                    checked={hfcHeaderDescBox}
                    onChange={newValue => setAttributes({ hfcHeaderDescBox: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHasHeaderBGimg
                            ? 'Show Header Dots Object :'
                            : 'Show Header Dots Object :'
                    }
                    checked={hfcHasHeaderBGimg}
                    onChange={newValue => setAttributes({ hfcHasHeaderBGimg: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-header-2'}>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        hfcHeaderPadding,
        hfcHeaderInnerWidth,
        hfcHeaderBGcolor,
        hfcHeaderLinksColor,
        hfcHeaderLinksHoverColor,
        hfcHeaderLinkCurrentColor,
        hfcHeaderIconColor,
        hfcHeaderLabelColor,
        hfcHeaderBtncolor,
        hfcHeaderBtnHovercolor,
        hfcHeaderBorderColor,
        hfcSubmenusBgHoverColor,
        hfcHeaderHasBorder,
        hfcHeaderIsTransparent,
        hfcHeaderIconsSize,
        hfcHeaderLabelSize,
        hfcHeaderIsSticky,
        hfcHeaderBoxShadow,
        hfcHeaderTitleBadge,
        hfcHasHeaderBGimg,
        hfcImageWidth,
    } = attributes;
    const hfcDynamicStyles = `
    .block-editor-block-list__block.wp-block.wp-block-hfc-blocks-header-2 {
      max-width: 100%;
    }
    #${id}.hfc-main-header-2 .wp-block-group__inner-container{
      max-width: 100%;
    }
    #${id}.hfc-main-header-2 {
        ${hfcHeaderHasBorder ? `border-bottom: 1px solid ` + hfcHeaderBorderColor : ``};
    }
    #${id}.hfc-main-header-2 .hfc-second-container {
      background-color: ${hfcHeaderBGcolor};
      position: relative;
      z-index: 999;
      padding: 0px 10px;
    }
    #${id}.hfc-main-header-2 .wp-block-columns {
      justify-content: space-between;
    }
    #${id}.hfc-main-header-2 .hfc-second-container:before{
      content: '';
      height: 100%;
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 3px;
      left: 0;
      ${hfcHasHeaderBGimg ? `background-image: url(${img});` : ''}
      background-repeat: repeat;
      z-index: -1;
    }
    #${id}.hfc-main-header-2 .hfc-col-header-1,
    #${id}.hfc-main-header-2 .hfc-col-header-2{
      max-width: ${hfcHeaderInnerWidth};
      margin: 0 auto;
      align-items: center!important;
    }
    #${id}.hfc-main-header-2 .hfc-first-container p,
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons {
      margin: 0;
      display: inline-block;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-social-links .wp-social-link{
      transition: 0.4s;
      transform: scale(1);
      list-style: none;
      line-height: 1;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-social-links .wp-social-link:hover{
      transform: scale(1.1);
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons a{
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
      padding: 10px 20px;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons>.wp-block-button .wp-block-button__link {
     background-color: ${hfcHeaderBtncolor};
     border-radius: 0;
    }
    #${id}.hfc-main-header-2 .hfc-first-container .wp-block-buttons>.wp-block-button .wp-block-button__link:hover {
     background-color: ${hfcHeaderBtnHovercolor};
    }
    #${id}.hfc-main-header-2 .hfc-col-left{
      flex-basis: 30%;
    }
    #${id}.hfc-main-header-2 .hfc-col-right{
      display: flex;
      gap: 15px;
      align-items: center;
      justify-content: flex-end;
      flex-basis: 70%;
    }
  #${id}.hfc-main-header-2 .hfc-first-container {
    background-color: #18202B;
    color: #fff;
  }
  #${id}.hfc-main-header-2 .hfc-first-container ul {
    gap: 0;
    margin: 0px;
    flex-wrap: nowrap;
  }
  #${id}.hfc-main-header-2 .hfc-first-container li {
    background-color: transparent;
    color: #fff;
    border-right: 1px solid rgba(209, 209, 209, 0.24);
    border-radius: 0;
    padding: 0 5px;
  }
  #${id}.hfc-main-header-2 .hfc-first-container li svg{
    width: ${hfcHeaderIconsSize}px;
    height: ${hfcHeaderIconsSize}px;
    fill: #fff;
  }
  #${id} .hfc-nav-header-2 > .wp-block-navigation-item.has-mega-menu, 
  #${id} .hfc-nav-header-2 > .wp-block-navigation-item.has-child {
    padding-right: 15px;
  }
  #${id}.hfc-main-header-2 .hfc-first-container,
  #${id}.hfc-main-header-2 .hfc-second-container{
    margin: 0;
  }
  #${id} .wp-block-navigation.hfc-nav-header-2{
    position: unset;
  }
  #${id} .wp-block-navigation.hfc-nav-header-2 > li.wp-block-navigation-item.has-child > a{
    position: relative;
  }
  #${id} .wp-block-navigation.hfc-nav-header-2 > li.wp-block-navigation-item.has-child > a::after{
    content: '';
    position: absolute;
    top: 50%;
    margin-top: -5px;
    margin-left: 4px;
    box-sizing: border-box;
    height: 8px;
    width: 8px;
    border-style: solid;
    border-color: ${hfcHeaderLinksColor};
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
  }
  #${id} .wp-block-navigation.hfc-nav-header-2 > li.wp-block-navigation-item.has-child > a:hover::after{
    border-color: ${hfcHeaderLinksHoverColor};
  }
  #${id} .wp-block-navigation .wp-block-navigation-link a:focus .wp-block-navigation-item__label, 
  #${id} .wp-block-navigation .wp-block-navigation-link.current-menu-item .wp-block-navigation-item__label{
    border-bottom: none!important;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .hfc-col-left .wp-block-site-logo{
    padding: 5px 0;
    max-width: ${hfcImageWidth}!important;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-item a.wp-block-navigation-item__content {
    color: ${hfcHeaderLinksColor};
    font-weight: bold;
    font-size: 18px;
    text-decoration: none;
    padding: 8px 16px;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-item a.wp-block-navigation-item__content:hover .wp-block-navigation-item__label{
    color: ${hfcHeaderLinksHoverColor};
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container > .wp-block-navigation-item > a.wp-block-navigation-item__content{
    padding: ${hfcHeaderPadding}px 0px;
    border-bottom: 4px solid transparent;
    line-height: 30px;
    display: inline-block;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container > .wp-block-navigation-item:hover > a.wp-block-navigation-item__content{
    border-bottom-color: ${hfcHeaderLinksHoverColor};
    color: ${hfcHeaderLinksHoverColor};
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-submenu .wp-block-navigation__submenu-icon{
    margin-top: -24px;
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-submenu .wp-block-navigation__submenu-icon svg{
    stroke: ${hfcHeaderLinksColor};
  }
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation-submenu:hover .wp-block-navigation__submenu-icon svg{
    stroke: ${hfcHeaderLinksHoverColor};
  }
  ${hfcHeaderTitleBadge ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[title]:after {
    content: attr(title);
    position: relative;
    top: -14px;
    font-size: 10px;
    font-weight: bold;
    line-height: 10px;
    text-transform: uppercase;
    display: inline-block;
    padding: 3px 4px;
    background: #F44336;
    color: #fff;
}
#${id} ul.hfc-nav-header-2 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]:after {
    top: 4px;
    left: 10px;
    height: 100%;
}` : ``}
#${id}.hfc-main-header-2 .wp-block-navigation-item:hover .wp-block-navigation-item__description{
    display: block;
    position: absolute;
    right: 50%;
    transform: translate(50%, 50%);
    min-width: 200px;
    max-width: 200px;
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    padding: 10px;
    border-radius: 5px;
}
  #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container{
    display: flex;
    gap: 25px;
  }
  #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[aria-current="page"] {
    color: ${hfcHeaderLinkCurrentColor} !important;
  }
  #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[aria-current="page"]:before {
      width: 100% !important;
      background: ${hfcHeaderLinkCurrentColor} !important;
  }
  ${hfcHeaderIsSticky ? `.hfc-main-header-2 {
      position: sticky;
      top: 0;
      z-index: 999;
  }` : ``}
  ${hfcHeaderIsTransparent ? `.hfc-main-header-2 {
      position: absolute;
      top: 0;
  }` : ``}
  ${hfcHeaderBoxShadow ? `.hfc-main-header-2 {
      box-shadow: 0 4px 7px rgb(199 199 199 / 10%);
  }` : ``}
  #${id} .hfc-icon-list-main{
     margin-top: 0;
  }
  #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
      background-color: transparent!important;
  }
  #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner span,
  #${id} .hfc-first-container .hfc-icon-list-main .wp-block-hfc-blocks-list-item a{
     color: ${hfcHeaderLabelColor}!important;
     font-size: ${hfcHeaderLabelSize}px!important;
 }
  #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner svg{
     height: ${hfcHeaderIconsSize}px!important;
     width: ${hfcHeaderIconsSize}px!important;
     color: ${hfcHeaderIconColor}!important;
  }
  #${id} .hfc-first-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
     padding: 0px!important;
  }
  #${id} .hfc-mega-menu .hfc-mm-1,
  #${id} .hfc-mega-menu .hfc-mm-2,
  #${id} .hfc-mega-menu .hfc-mm-3,
  #${id} .hfc-mega-menu .hfc-mm-4{
     margin-top: 38px!important;
  }
  /* For site loading time header broken issue */
  #${id}.hfc-main-header-2 .wp-block-navigation__container .wp-block-navigation-item{
      list-style-type: none;
      white-space: nowrap;
  }
  #${id}.hfc-main-header-2 .wp-block-navigation__container{
      margin: 0px;
  }
  #${id}.hfc-main-header-2 .wp-block-navigation__container,
  #${id}.hfc-main-header-2 ul.wp-block-navigation-submenu{
      padding-left: 0px;
  }
  @media (min-width: 599px){
     #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-open:not(.always-shown),
     #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container:not(.is-menu-open) .wp-block-navigation__responsive-container-close{
        display: none;
  }
#${id} .wp-block-navigation .has-child .hfc-submenu-wrapper{
      align-items: normal;
      display: flex;
      flex-direction: column;
      height: 0;
      left: -1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      top: 100%;
      transition: opacity .1s linear;
      visibility: hidden;
      width: 0;
      z-index: 2;
 }
 #${id} .wp-block-navigation .has-child:hover > .hfc-submenu-wrapper{
      opacity: 1!important;
      height: auto!important;
      overflow: visible!important;
      visibility: visible!important;
  }
  }
  @media(max-width: 782px){
     #${id}.hfc-main-header-2 .hfc-first-container .hfc-col-header-2 {
        flex-direction: column;
        gap: 10px;
    }
    #${id}.hfc-main-header-2 .wp-block-columns .wp-block-column:first-child{
        flex-basis: 30% !important;
        margin: 0px;
    }
    #${id}.hfc-main-header-2 .wp-block-columns{
        flex-wrap: nowrap !important;
        align-items: center!important;
    }
}
@media(max-width: 599px){
/* Reset */
  p,li{
      font-size: 16px!important;
  }
    #${id}.hfc-main-header-2 .hfc-col-header-2 .hfc-col-left img{
        width: 120px;
    }
    #${id}.hfc-main-header-2 .hfc-second-container{
        padding: 10px;
    }
    #${id} .hfc-col-header-2 .hfc-nav-header-2:has(.has-modal-open) .wp-block-navigation__responsive-container-open,
    #${id}.hfc-main-header-2 .hfc-col-right-header-2{
        display: none !important;
    }
    #${id} .hfc-col-header-2 .wp-block-navigation__responsive-container.is-menu-open {
        animation: none;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-open{
        position: absolute !important;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        transition: 0.4s;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-close{
        position: absolute;
        top: -44px;
        right: 15px;
        z-index: 9999;
        background-color: transparent!important;
        transition: 0.4s;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-open::before, 
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-close::before{
        content: "Menu";
        font-size: 14px;
        position: absolute;
        font-weight: bold;
        color:${hfcHeaderLinksColor};
        right: 25px;
        top: 5px;
        white-space: nowrap;
        line-height: 1;
        text-transform: uppercase;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-open:hover::before, 
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-close:hover::before{
      color: ${hfcHeaderLinksHoverColor};
   }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-open::after, 
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-close::after{
        content: "";
        box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 8px 2px inset;
        height: 35px;
        width: 90px;
        position: absolute;
        right: -8px;
        top: -6px;
        border-radius: 10px;
        z-index: -1;
    }
    #${id}.hfc-main-header-2 .hfc-nav-header-2 .wp-block-navigation__responsive-dialog{
        margin-top: 0!important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container-content{
        padding-top: 0!important;
    }
    #${id}.hfc-main-header-2 .hfc-nav-header-2 .wp-block-navigation-item .wp-block-navigation-item__content:hover{
        background-color: ${hfcSubmenusBgHoverColor}!important;
    }
    #${id}.hfc-main-header-2 header.wp-block-group .wp-block-columns {
        flex-direction: row;
        flex-wrap: nowrap !important;
        gap: 0px;
    }
    /* Mobile Menu Inner */
    #${id} .hfc-col-right-header-2 .wp-block-buttons a.wp-block-button__link{
        font-size: 12px!important;
        padding: 10px!important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation:not(.has-background) .wp-block-navigation__responsive-container.is-menu-open{
        background-color: transparent!important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open {
        padding: 0px;
        height: 100vh;
        position: absolute;
        top: 100%;
        width: 100%;
        margin-top: 1px;
        overflow: visible;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation {
        display: block !important;
        width: 100%;
        background-color: #fff !important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container.is-menu-open a.wp-block-navigation-item__content {
        display: inline-block;
        width: 100%;
        padding: 10px;
        line-height: 30px;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-item:not(:last-child){
        border-bottom: 1px solid #b7b7b7;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation-item.has-child .wp-block-navigation-submenu li:first-child {
        border-top: 1px solid #b7b7b7;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open ul.wp-block-navigation-submenu {
        padding: 0;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation__responsive-container .wp-block-navigation__submenu-container{
        width: 100%!important;
        border-top: none!important
    }
    #${id} .hfc-nav-header-2 ul.wp-block-navigation__submenu-container{
        display: none!important;
    }
    #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:before{
        background: none!important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation-item.has-child li a{
        padding: 10px 0!important;
    }
   #${id} .hfc-nav-header-2 > .wp-block-navigation-item.has-mega-menu, 
   #${id} .hfc-nav-header-2 > .wp-block-navigation-item.has-child {
       padding-right: 0;
   }
    #${id} .wp-block-navigation.hfc-nav-header-2 li.wp-block-navigation-item.has-child{
        border-bottom: none;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child  a{
        padding-left: 30px!important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-2 li.wp-block-navigation-item.has-child > a{
        position: relative;
        box-sizing: border-box;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        right: 18px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-2 > li.wp-block-navigation-item.has-child > a::before,
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 50px;
        width: 50px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-2 li.wp-block-navigation-item.has-child > a::after{
        top: 25px;
        right: 20px;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child {
        position: relative!important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a,
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label{
        position: relative!important;
        padding-left: 30px!important;
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before,
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        content: '';
        position: absolute;
        left: 10px;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(-45deg);
    }
    #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content::after{
        content: '';
        position: absolute;
        right: 20px;
        height: 8px;
        width: 8px;
        top: 20px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
      #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before{
        top: 20px;
      }
      #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        top: 6px;
      }
      #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:hover:before,
      #${id}.hfc-main-header-2 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
      }
      #${id} .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu a::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 50px;
        width: 50px;
      }
    #${id} .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu a::after{
        top: 20px!important;
        right: 20px;
    }
    #${id}.hfc-main-header-2 .hfc-first-container {
        display: none;
    }
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        right: 10px;
    }
    div#modal-1 {
        padding: 30px;
    }
    #${id} ul.hfc-nav-header-2 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]:after{
        top: 0px;
    }
    #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container{
        gap: 10px;
    }
    #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__submenu-container{
        padding: 0 0 0 20px;
    }
    #${id}.hfc-main-header-2 .hfc-second-container .wp-block-navigation__container > .wp-block-navigation-item > a.wp-block-navigation-item__content{
        padding: 10px;
        border-bottom: none;
        box-sizing: border-box;
        line-height: 30px;
        overflow: hidden;
    }
    .wp-block-navigation__responsive-container-close {
        position: absolute;
        right: 0px;
        top: 0;
        z-index: 2;
    }
}`;
    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-header-2'}>
                <InnerBlocks.Content />
            </div>
        </>
    )
}